export const TABLET_L = 1024;
export const TABLET_M = 834;
export const TABLET_S = 768;
export const MOBILE_L = 429;
export const MOBILE_M = 375;
export const MOBILE_S = 325;
